import type { FeedbackContent, FeedbackKind } from "./types";

export const KIND_LABELS: Record<FeedbackKind, string> = {
  feature_request: "Feature request",
  bug_report: "Bug report",
  general_feedback: "General feedback",
  nps: "NPS",
  rating: "Rating",
};

/** Short headline for the kind column (adds the score for nps/rating). */
export function summarizeKind(content: FeedbackContent): string {
  switch (content.kind) {
    case "nps":
      return `NPS ${content.score}`;
    case "rating":
      return `Rating ${content.score}/${content.outOf}`;
    default:
      return KIND_LABELS[content.kind];
  }
}

/** The free-text detail (message / reason / comment), or "" when there is none. */
export function feedbackDetail(content: FeedbackContent): string {
  switch (content.kind) {
    case "feature_request":
    case "bug_report":
    case "general_feedback":
      return content.text;
    case "nps":
      return content.reason ?? "";
    case "rating":
      return content.comment ?? "";
  }
}
